module.exports = __webpack_public_path__ + "img/switzerland-min.d1fd29d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countries/switzerland-min.jpg
// module id = z6nk
// module chunks = 1